import React, { useEffect } from 'react';
import SetupMandates from '@/pages/SetupMandates';
import './DigioMandateSetup.css';

interface DigioMandateSetupProps {
  value?: any;
  onChange?: (data: any) => void;
  onDone?: () => void;
  isBuilderMode?: boolean;
  registerSubmit?: (submitFn: () => Promise<boolean>) => void;
}

/**
 * Wrapper component for Digio eMandate (UPI + NACH) setup page
 * Used in journey builder to integrate the existing SetupMandates page
 * 
 * Features:
 * - UPI Autopay Mandate (Digio)
 * - NACH Mandate (Digio)
 * - Sequential flow: UPI first, then NACH
 * - Popup-based mandate registration
 * - Auto-advances journey after NACH completion
 * 
 * Note: Uses CSS to hide unnecessary layers from SetupMandates page
 */
export default function DigioMandateSetup({ 
  value, 
  onChange, 
  onDone,
  isBuilderMode = false,
  registerSubmit 
}: DigioMandateSetupProps) {
  useEffect(() => {
    console.log('[DigioMandateSetup] Wrapper mounted', { value, isBuilderMode });
  }, [value, isBuilderMode]);

  // The SetupMandates page handles its own navigation after NACH completion
  // It redirects to /loan-application which will load the next journey page
  // So we don't need to call onDone() here - the page handles it internally

  // Render SetupMandates with custom wrapper to hide layers
  return (
    <div className="digio-mandate-wrapper">
      <SetupMandates isBuilderMode={isBuilderMode} />
    </div>
  );
}
